function camcomLightbox(elements, itemSelector) {

    var $ = jQuery;

    if(!itemSelector){

        itemSelector = 'img';

    }

    if($(itemSelector).is('picture')){

        itemSelector = itemSelector + ' img';

    }

    console.log('Lightbox GO!!!', itemSelector);
    console.log('Lightbox Elements - ', elements);

/*    var ajax = new XMLHttpRequest();
    ajax.open('GET', ajax_variables.template_directory_uri + '/images/svg-symbols.svg', true);
    ajax.send();

    ajax.onload = function (e) {

        var div = document.createElement('div');
        div.className = 'is-hidden';
        div.innerHTML = ajax.responseText;
        document.body.insertBefore(div, document.body.childNodes[0]);

    };*/

    $(elements).slickLightbox({
        itemSelector: itemSelector,
        src: function (elem) {

            var elem = $(elem);

            if(!elem.is('img')){

                console.log('Not Image -> Dive');
                elem = $(elem).find('img');

            }

            if (elem.attr('srcset')) {

                var srcset = elem.attr('srcset').split(','),
                    src = srcset[srcset.length - 1].split(' ');

                console.log('Lightbox Source - ', src[1]);

                if (src[2].slice(0, -1) >= 600) {

                    return src[1];

                } else {

                    return elem.attr('src');

                }

            } else {

                return elem.attr('src');

            }

        },
        lazy: true,
        useHistoryApi: true,
        slick: {
            prevArrow: '<svg class="icon slick-prev" viewBox="0 0 100 100"><use xlink:href="#chevron-left" /></svg>',
            nextArrow: '<svg class="icon slick-next" viewBox="0 0 100 100"><use xlink:href="#chevron-right" /></svg>',
        }
    });

}